import menus from './Menus'

// Array of sections
export default [...menus]
